import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { LeafletMapTitle, MapTitle } from "../../../../Constants/Constants";
import AustraliaMap from "./AustraliaMap";
import IndiaMap from "./IndiaMap";
import UsaMap from "./UsaMap";
import WorldMap from "./WorldMap";

const LeafletMapsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={LeafletMapTitle} parent={MapTitle} />
      <Container fluid>
        <Row>
          <WorldMap />
          <UsaMap />
          <IndiaMap />
          <AustraliaMap />
        </Row>
      </Container>
    </>
  );
};
export default LeafletMapsContainer;
